import React from 'react'
import { Button } from '../../ui/button';
import { Textarea } from '../../ui/textarea';
import { COMMON_CONSTANTS } from '../../sharedfiles/Constants'
import { Check, X, MessageSquare, AlertCircle } from 'lucide-react'

const CommentBox = (props) => {
    const { placeholder, value, errorMsg, onIpChange = () => { }, onSave = () => { }, onCancel = () => { }, ...rest } = props

    return (
        <>
            {/* Comment Box Container */}
            <div className='rounded-lg border bg-card p-6 space-y-5 shadow-sm'>
                {/* Header Section */}
                <div className='flex items-center gap-2 pb-4 border-b border-border'>
                    <MessageSquare className='h-5 w-5 text-primary flex-shrink-0' />
                    <h3 className='text-base font-semibold text-foreground'>Add Your Comment</h3>
                </div>

                {/* Textarea Section */}
                <div className='space-y-3'>
                    <div className='relative'>
                        <Textarea
                            placeholder={placeholder || 'Enter your comment here...'}
                            value={value}
                            onChange={(e) => onIpChange(e)}
                            className={`min-h-[120px] resize-none transition-colors ${errorMsg ? 'border-destructive focus-visible:ring-destructive' : ''
                                }`}
                        />
                        {value && !errorMsg && (
                            <div className='absolute right-4 top-4 text-green-600 bg-card rounded-full p-1'>
                                <Check className='h-5 w-5' />
                            </div>
                        )}
                    </div>

                    {/* Error Message */}
                    {errorMsg && (
                        <div className='flex items-start gap-3 p-3 rounded-md bg-destructive/10 border border-destructive/30'>
                            <AlertCircle className='h-4 w-4 text-destructive flex-shrink-0 mt-0.5' />
                            <p className='text-xs text-destructive font-medium'>{errorMsg}</p>
                        </div>
                    )}

                    {/* Character Count */}
                    {value && (
                        <div className='flex justify-between items-center'>
                            <span className={`text-xs font-medium ${errorMsg ? 'text-destructive' : 'text-muted-foreground'
                                }`}>
                                {value.length} character{value.length !== 1 ? 's' : ''}
                            </span>
                            {!errorMsg && value.length > 0 && (
                                <span className='text-xs text-green-600 font-medium flex items-center gap-1'>
                                    <Check className='h-3 w-3' />
                                    Ready to submit
                                </span>
                            )}
                        </div>
                    )}
                </div>

                {/* Action Buttons */}
                <div className='flex justify-end gap-3 pt-4 border-t border-border'>
                    <Button
                        variant="outline"
                        size="sm"
                        type='button'
                        id='editplayercancel'
                        onClick={() => onCancel()}
                        className='gap-2'
                    >
                        <X className='h-4 w-4' />
                        <span>{COMMON_CONSTANTS.cancel}</span>
                    </Button>
                    <Button
                        variant="default"
                        size="sm"
                        type='button'
                        id='editplayersave'
                        onClick={(e) => onSave(e)}
                        disabled={!value || errorMsg}
                        className='gap-2'
                    >
                        <Check className='h-4 w-4' />
                        <span>{COMMON_CONSTANTS.save}</span>
                    </Button>
                </div>
            </div>
        </>
    )
}

export default CommentBox